export const endpoint = {
	base: "",
	enqueteId: `/:enqueteId`,
} as const;
